/** Core game constants for Minesweeper Flags. */

/** Board is a fixed 16x16 grid. */
export const BOARD_SIZE = 16;

/** Total cells on the board. */
export const CELL_COUNT = BOARD_SIZE * BOARD_SIZE; // 256

/**
 * Number of mines. 51 is the MSN Minesweeper Flags standard: an odd count over
 * 256 cells guarantees no ties — the first player to claim a majority wins.
 */
export const MINE_COUNT = 51;

/** Claiming this many mines (a majority of 51) ends the game immediately. */
export const WIN_THRESHOLD = Math.floor(MINE_COUNT / 2) + 1; // 26

/** Each player may detonate one 3x3 bomb power-up per game. */
export const BOMB_RADIUS = 1; // 1 => 3x3 area

/** How long (ms) a pre-start (waiting/ready) game's Durable Object lingers with
 * no activity before cleanup — short, since it's just an open lobby entry. */
export const GAME_IDLE_CLEANUP_MS = 30 * 60 * 1000; // 30 minutes

/** How long an ACTIVE (both players seated, in progress) game survives with no
 * activity — long enough to resume after a real gap (a busy day, overnight)
 * without keeping truly abandoned matches around forever. Any activity
 * (a move, chat, or even just reconnecting) resets this. */
export const GAME_ACTIVE_IDLE_CLEANUP_MS = 24 * 60 * 60 * 1000; // 24 hours

/** How long (ms) a finished game's Durable Object lingers before cleanup. */
export const GAME_FINISHED_CLEANUP_MS = 5 * 60 * 1000; // 5 minutes after game over

/** Randomized "thinking" delay range (ms) before the AI opponent plays its
 * turn — long enough to feel deliberate, short enough not to be annoying. */
export const AI_THINK_MIN_MS = 900;
export const AI_THINK_MAX_MS = 2500;
